module.exports = __webpack_public_path__ + "img/GIAO_DUC_DAO_TAO.19402238.svg";